(function() {
  'use strict';

  // ============================================================
  // SIZE DATA — default product size charts
  // ============================================================
  var SIZE_DATA = {
    'washed-tee': [
      { name: 'S',   weight: [55, 65],  width: 56, length: 70 },
      { name: 'M',   weight: [65, 75],  width: 59, length: 72 },
      { name: 'L',   weight: [75, 85],  width: 62, length: 73 },
      { name: 'XL',  weight: [85, 95],  width: 65, length: 75 },
      { name: '2XL', weight: [95, 110], width: 67, length: 77 }
    ],
    'oversized-tee': [
      { name: 'S',   weight: [55, 65],  width: 56, length: 70 },
      { name: 'M',   weight: [65, 75],  width: 59, length: 72 },
      { name: 'L',   weight: [75, 85],  width: 62, length: 73 },
      { name: 'XL',  weight: [85, 95],  width: 65, length: 75 },
      { name: '2XL', weight: [95, 110], width: 67, length: 77 }
    ],
    'long-sleeve': [
      { name: 'M',  weight: [65, 75], width: 59, length: 72 },
      { name: 'L',  weight: [75, 85], width: 62, length: 73 },
      { name: 'XL', weight: [85, 95], width: 65, length: 75 }
    ],
    'hoodie': [
      { name: 'S',   weight: [55, 65],  width: 56, length: 69 },
      { name: 'M',   weight: [65, 75],  width: 58, length: 70 },
      { name: 'L',   weight: [75, 85],  width: 62, length: 73 },
      { name: 'XL',  weight: [85, 95],  width: 64, length: 74 },
      { name: '2XL', weight: [95, 110], width: 66, length: 76 }
    ],
    'crewneck': [
      { name: 'S',   weight: [55, 65],  width: 56, length: 69 },
      { name: 'M',   weight: [65, 75],  width: 60, length: 70 },
      { name: 'L',   weight: [75, 85],  width: 62, length: 73 },
      { name: 'XL',  weight: [85, 95],  width: 65, length: 76 },
      { name: '2XL', weight: [95, 110], width: 66, length: 78 }
    ]
  };

  // ============================================================
  // ICON URLS — fetched from Shopify Files CDN
  // ============================================================
  var ICON_BASE = 'https://cdn.shopify.com/s/files/1/0625/5539/0052/files/';
  var ICON_URLS = {
    gender: { male: ICON_BASE + 'sf-gender-male.svg', female: ICON_BASE + 'sf-gender-female.svg' },
    tummy: { flat: ICON_BASE + 'sf-tummy-flat.svg', average: ICON_BASE + 'sf-tummy-average.svg', round: ICON_BASE + 'sf-tummy-round.svg' },
    hips: { narrow: ICON_BASE + 'sf-hips-narrow.svg', average: ICON_BASE + 'sf-hips-average.svg', wide: ICON_BASE + 'sf-hips-wide.svg' },
    bra: { A: ICON_BASE + 'sf-bra-a.svg', B: ICON_BASE + 'sf-bra-b.svg', C: ICON_BASE + 'sf-bra-c.svg', D: ICON_BASE + 'sf-bra-d.svg', 'DD+': ICON_BASE + 'sf-bra-dd.svg' },
    fit: { fitted: ICON_BASE + 'sf-fit-fitted.svg', regular: ICON_BASE + 'sf-fit-regular.svg', relaxed: ICON_BASE + 'sf-fit-relaxed.svg' }
  };

  // Fetch SVG and inject inline (so currentColor works)
  function loadSvgInline(url, container) {
    fetch(url).then(function(r) { return r.text(); }).then(function(svg) {
      container.innerHTML = svg;
    });
  }

  // ============================================================
  // CALCULATOR — BMI-based with body shape modifiers
  // ============================================================
  function calculateSize(weight, height, gender, tummy, hips, bra, fit, isOversized, productType) {
    var sizes = SIZE_DATA[productType];
    if (!sizes || sizes.length === 0) return null;

    var heightM = height / 100;
    var bmi = weight / (heightM * heightM);
    var modifier = 0;

    if (tummy === 'round') modifier += 1.2;
    else if (tummy === 'average') modifier += 0.3;

    if (hips === 'wide') modifier += 0.6;
    else if (hips === 'narrow') modifier -= 0.3;

    if (gender === 'female') {
      if (bra === 'DD+') modifier += 1.8;
      else if (bra === 'D') modifier += 1.0;
      else if (bra === 'C') modifier += 0.3;
      else if (bra === 'B') modifier += 0;
      else if (bra === 'A') modifier -= 0.3;
    }

    if (!isOversized) {
      if (fit === 'relaxed') modifier += 1.5;
      else if (fit === 'fitted') modifier -= 1.0;
    }

    var effectiveBmi = bmi + modifier;

    var bmiBoundaries = [];
    for (var i = 0; i < sizes.length; i++) {
      bmiBoundaries.push({
        name: sizes[i].name,
        bmiLow: sizes[i].weight[0] / (heightM * heightM),
        bmiHigh: sizes[i].weight[1] / (heightM * heightM),
        size: sizes[i],
        idx: i
      });
    }

    var matchIdx = 0;
    if (effectiveBmi < bmiBoundaries[0].bmiLow) {
      matchIdx = 0;
    } else if (effectiveBmi > bmiBoundaries[bmiBoundaries.length - 1].bmiHigh) {
      matchIdx = bmiBoundaries.length - 1;
    } else {
      for (var i = 0; i < bmiBoundaries.length; i++) {
        if (effectiveBmi >= bmiBoundaries[i].bmiLow && effectiveBmi <= bmiBoundaries[i].bmiHigh) {
          matchIdx = i;
          break;
        }
        if (i < bmiBoundaries.length - 1 &&
            effectiveBmi > bmiBoundaries[i].bmiHigh &&
            effectiveBmi < bmiBoundaries[i + 1].bmiLow) {
          matchIdx = i + 1;
          break;
        }
      }
    }

    var matched = bmiBoundaries[matchIdx];
    var bmiRange = matched.bmiHigh - matched.bmiLow;
    var posInRange = bmiRange > 0 ? (effectiveBmi - matched.bmiLow) / bmiRange : 0.5;
    var sizedUpBySafeZone = false;

    if (posInRange > 0.75 && matchIdx < sizes.length - 1) {
      matchIdx = matchIdx + 1;
      sizedUpBySafeZone = true;
    }

    if (!sizedUpBySafeZone && height >= 190 && matchIdx < sizes.length - 1) {
      matchIdx = matchIdx + 1;
    }

    var recommended = sizes[matchIdx];
    var isBetween = false;
    var recBoundary = bmiBoundaries[matchIdx];
    var recPos = bmiRange > 0 ? (effectiveBmi - recBoundary.bmiLow) / (recBoundary.bmiHigh - recBoundary.bmiLow) : 0.5;

    if (matchIdx > 0 && recPos < 0.3) {
      isBetween = true;
    }

    return {
      recommended: recommended,
      recommendedIdx: matchIdx,
      isBetween: isBetween,
      nextSize: matchIdx < sizes.length - 1 ? sizes[matchIdx + 1] : null,
      smallerSize: matchIdx > 0 ? sizes[matchIdx - 1] : null,
      allSizes: sizes,
      bmi: Math.round(bmi * 10) / 10,
      effectiveBmi: Math.round(effectiveBmi * 10) / 10,
      fit: isOversized ? 'Oversized' : (fit.charAt(0).toUpperCase() + fit.slice(1))
    };
  }

  // ============================================================
  // UI — modal state, navigation, selections
  // ============================================================
  var modal, gender, tummy, hips, bra, fit, currentStepIdx, isOversized, productType, sizeDataOverride, sectionId, sizeVariantMap;

  function init() {
    modal = document.querySelector('.sf-overlay');
    if (!modal) return;

    var config = modal.dataset;
    isOversized = config.oversized === 'true';
    productType = config.productType || 'oversized-tee';

    // Parse size-to-variant map from theme editor setting
    sizeVariantMap = {};
    if (config.sizeVariantMap) {
      try { sizeVariantMap = JSON.parse(config.sizeVariantMap); } catch(e) {}
    }

    var customDataEl = document.getElementById('sf-custom-size-data');
    if (customDataEl) {
      try {
        var parsed = JSON.parse(customDataEl.textContent);
        if (parsed && parsed.length) sizeDataOverride = parsed;
      } catch(e) {}
    }

    resetModal();
    renderIcons();

    var trigger = document.querySelector('.sf-trigger');
    if (trigger) {
      sectionId = trigger.dataset.sectionId;
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        openModal();
      });
    }

    var closeBtn = modal.querySelector('.sf-modal-close');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    modal.addEventListener('click', function(e) {
      if (e.target === modal) closeModal();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeModal();
    });

    modal.querySelectorAll('[data-sf-next]').forEach(function(btn) {
      btn.addEventListener('click', goNext);
    });
    modal.querySelectorAll('[data-sf-back]').forEach(function(btn) {
      btn.addEventListener('click', goBack);
    });
    modal.querySelectorAll('[data-sf-calc]').forEach(function(btn) {
      btn.addEventListener('click', calcResult);
    });
    modal.querySelectorAll('[data-sf-reset]').forEach(function(btn) {
      btn.addEventListener('click', resetModal);
    });
    modal.querySelectorAll('[data-sf-addtocart]').forEach(function(btn) {
      btn.addEventListener('click', addToCart);
    });

    modal.querySelectorAll('.sf-gender-btn').forEach(function(btn) {
      btn.addEventListener('click', function() { selectGender(this); });
    });

    var hSlider = modal.querySelector('#sfHeightSlider');
    var wSlider = modal.querySelector('#sfWeightSlider');
    if (hSlider) hSlider.addEventListener('input', function() { updateSlider('height', this.value); });
    if (wSlider) wSlider.addEventListener('input', function() { updateSlider('weight', this.value); });
  }

  function getSteps() {
    return ['gender', 'height', 'weight', 'body', 'fit'];
  }

  function updateProgress() {
    var steps = getSteps();
    var prog = modal.querySelector('.sf-progress');
    prog.innerHTML = '';
    for (var i = 0; i < steps.length; i++) {
      var dot = document.createElement('div');
      dot.className = 'sf-progress-dot';
      if (i < currentStepIdx) dot.classList.add('done');
      if (i === currentStepIdx) dot.classList.add('active');
      prog.appendChild(dot);
    }
  }

  function showCurrentStep() {
    var steps = getSteps();
    modal.querySelectorAll('.sf-step').forEach(function(s) { s.classList.remove('active'); });
    modal.querySelector('#sf-step-' + steps[currentStepIdx]).classList.add('active');

    if (steps[currentStepIdx] === 'fit') {
      modal.querySelector('#sfFitContent').style.display = isOversized ? 'none' : 'block';
      modal.querySelector('#sfOversizedNote').style.display = isOversized ? 'block' : 'none';
    }
    updateProgress();
  }

  function goNext() {
    var steps = getSteps();
    if (currentStepIdx < steps.length - 1) {
      currentStepIdx++;
      showCurrentStep();
    }
  }

  function goBack() {
    if (currentStepIdx > 0) {
      currentStepIdx--;
      showCurrentStep();
    }
  }

  function selectGender(btn) {
    modal.querySelectorAll('.sf-gender-btn').forEach(function(b) { b.classList.remove('selected'); });
    btn.classList.add('selected');
    gender = btn.dataset.value;
    modal.querySelector('#sfBtnGender').disabled = false;
    modal.querySelector('#sfBraSection').style.display = gender === 'female' ? 'block' : 'none';
  }

  function updateSlider(type, val) {
    modal.querySelector('#sf' + type.charAt(0).toUpperCase() + type.slice(1) + 'Value').textContent = val + (type === 'height' ? ' cm' : ' KG');
  }

  function selectBody(btn) {
    var group = btn.dataset.group;
    btn.parentElement.querySelectorAll('.sf-body-btn').forEach(function(b) { b.classList.remove('selected'); });
    btn.classList.add('selected');
    if (group === 'tummy') tummy = btn.dataset.value;
    if (group === 'hips') hips = btn.dataset.value;
  }

  function selectBra(btn) {
    modal.querySelectorAll('.sf-bra-btn').forEach(function(b) { b.classList.remove('selected'); });
    btn.classList.add('selected');
    bra = btn.dataset.value;
  }

  function selectFit(btn) {
    modal.querySelectorAll('.sf-fit-btn').forEach(function(b) { b.classList.remove('selected'); });
    btn.classList.add('selected');
    fit = btn.dataset.value;
  }

  function calcResult() {
    var weight = parseInt(modal.querySelector('#sfWeightSlider').value);
    var height = parseInt(modal.querySelector('#sfHeightSlider').value);

    var activeSizeData = sizeDataOverride || SIZE_DATA[productType];
    if (!activeSizeData) return;

    var tempKey = '__sf_active__';
    SIZE_DATA[tempKey] = activeSizeData;
    var result = calculateSize(weight, height, gender, tummy, hips, bra, fit, isOversized, tempKey);
    delete SIZE_DATA[tempKey];

    if (!result) return;

    var rec = result.recommended;
    modal.querySelector('#sfResultSize').textContent = rec.name;
    modal.querySelector('#sfResultWeight').textContent = rec.weight[0] + '\u2013' + rec.weight[1] + ' KG';
    modal.querySelector('#sfResultWidth').textContent = rec.width + ' cm';
    modal.querySelector('#sfResultLength').textContent = rec.length + ' cm';
    modal.querySelector('#sfResultFit').textContent = result.fit;

    var betweenEl = modal.querySelector('#sfBetweenNote');
    if (result.isBetween && result.smallerSize) {
      betweenEl.style.display = 'block';
      modal.querySelector('#sfBetweenRec').textContent = 'You could also fit ' + result.smallerSize.name + ' for a tighter fit';
    } else {
      betweenEl.style.display = 'none';
    }

    var html = '<tr><th>Size</th><th>Weight</th><th>Width</th><th>Length</th></tr>';
    activeSizeData.forEach(function(s) {
      var isRec = s.name === rec.name;
      html += '<tr class="' + (isRec ? 'recommended' : '') + '">';
      html += '<td>' + s.name + '</td>';
      html += '<td>' + s.weight[0] + '\u2013' + s.weight[1] + '</td>';
      html += '<td>' + s.width + '</td>';
      html += '<td>' + s.length + '</td>';
      html += '</tr>';
    });
    modal.querySelector('#sfSizeTable').innerHTML = html;

    // Build WhatsApp message with all selections
    var heightVal = modal.querySelector('#sfHeightSlider').value;
    var productName = document.querySelector('.product__title h1');
    productName = productName ? productName.textContent.trim() : 'this product';
    var waMsg = 'Hey Turtle! I used the Size Finder for *' + productName + '* and need help:\n\n'
      + 'Gender: ' + gender + '\n'
      + 'Height: ' + heightVal + ' cm\n'
      + 'Weight: ' + weight + ' KG\n'
      + 'Tummy: ' + tummy + '\n'
      + 'Hips: ' + hips + '\n'
      + (gender === 'female' ? 'Bra cup: ' + bra + '\n' : '')
      + 'Fit preference: ' + result.fit + '\n\n'
      + 'Recommended size: *' + rec.name + '*\n'
      + (result.isBetween && result.smallerSize ? '(Between ' + result.smallerSize.name + ' and ' + rec.name + ')\n' : '')
      + '\nCan you help me confirm my size?';
    var waLink = modal.querySelector('.sf-result-whatsapp-btn');
    if (waLink) waLink.href = 'https://wa.me/201065463277?text=' + encodeURIComponent(waMsg);

    modal.querySelectorAll('.sf-step').forEach(function(s) { s.classList.remove('active'); });
    modal.querySelector('#sf-step-result').classList.add('active');
    modal.querySelector('.sf-progress').innerHTML = '';
  }

  function openModal() {
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    resetModal();
  }

  function closeModal() {
    modal.classList.remove('active');
    document.body.style.overflow = '';
  }

  // Default aliases for auto-matching when no theme editor map is set
  var SIZE_ALIASES = {
    'S': ['S', 'Small'],
    'M': ['M', 'Medium'],
    'L': ['L', 'Large'],
    'XL': ['XL', 'X-Large'],
    '2XL': ['2XL', 'XXL', 'XX-Large']
  };

  function sizeMatches(recSize, variantSizeValue) {
    // If theme editor has a map entry for this size, use it (exact match on full value)
    if (sizeVariantMap && sizeVariantMap[recSize]) {
      return variantSizeValue === sizeVariantMap[recSize];
    }

    // Fallback: auto-match using first word + aliases
    var firstWord = variantSizeValue.split(' ')[0].split('(')[0].trim();
    if (firstWord === recSize) return true;
    var aliases = SIZE_ALIASES[recSize];
    if (aliases) {
      for (var a = 0; a < aliases.length; a++) {
        if (firstWord === aliases[a]) return true;
      }
    }
    return false;
  }

  function addToCart() {
    var recSize = modal.querySelector('#sfResultSize').textContent; // e.g. "M", "XL", "2XL"

    var variantMapEl = document.getElementById('sf-variant-map');
    if (!variantMapEl) return;

    var variants;
    try { variants = JSON.parse(variantMapEl.textContent); } catch(e) { return; }

    var productSection = document.getElementById('MainProduct-' + sectionId);
    if (!productSection) productSection = document;

    var form = productSection.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;

    var currentVariantId = parseInt(idInput.value);

    // Find current variant's non-size options (color etc)
    var currentOtherOpts = [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === currentVariantId) {
        currentOtherOpts = variants[i].options.slice(1);
        break;
      }
    }

    // Find variant: recommended size + same color
    var targetVariantId = null;
    for (var i = 0; i < variants.length; i++) {
      var opts = variants[i].options;
      if (!opts || !opts.length) continue;
      if (!sizeMatches(recSize, opts[0])) continue;

      // Match other options (color etc)
      var otherOpts = opts.slice(1);
      var allMatch = true;
      for (var j = 0; j < otherOpts.length; j++) {
        if (j < currentOtherOpts.length && otherOpts[j] !== currentOtherOpts[j]) {
          allMatch = false;
          break;
        }
      }
      if (allMatch) {
        targetVariantId = variants[i].id;
        break;
      }
    }

    // Fallback: just match size, any color
    if (!targetVariantId) {
      for (var i = 0; i < variants.length; i++) {
        var opts = variants[i].options;
        if (!opts || !opts.length) continue;
        if (sizeMatches(recSize, opts[0])) {
          targetVariantId = variants[i].id;
          break;
        }
      }
    }

    if (!targetVariantId) return;

    // Set variant ID and submit
    idInput.value = targetVariantId;
    idInput.disabled = false;

    closeModal();

    var addBtn = form.querySelector('.product-form__submit');
    if (addBtn && !addBtn.disabled) {
      addBtn.click();
    }
  }

  function resetModal() {
    currentStepIdx = 0;
    gender = null;
    tummy = 'flat';
    hips = 'average';
    bra = 'C';
    fit = 'regular';

    modal.querySelectorAll('.sf-gender-btn').forEach(function(b) { b.classList.remove('selected'); });
    var genderBtn = modal.querySelector('#sfBtnGender');
    if (genderBtn) genderBtn.disabled = true;

    var hSlider = modal.querySelector('#sfHeightSlider');
    var wSlider = modal.querySelector('#sfWeightSlider');
    if (hSlider) hSlider.value = 170;
    if (wSlider) wSlider.value = 70;
    var hVal = modal.querySelector('#sfHeightValue');
    var wVal = modal.querySelector('#sfWeightValue');
    if (hVal) hVal.textContent = '170 cm';
    if (wVal) wVal.textContent = '70 KG';

    modal.querySelectorAll('.sf-body-btn').forEach(function(b) { b.classList.remove('selected'); });
    var flatBtn = modal.querySelector('.sf-body-btn[data-value="flat"]');
    if (flatBtn) flatBtn.classList.add('selected');
    var avgHip = modal.querySelector('.sf-body-btn[data-group="hips"][data-value="average"]');
    if (avgHip) avgHip.classList.add('selected');

    modal.querySelectorAll('.sf-bra-btn').forEach(function(b) { b.classList.remove('selected'); });
    var cBtn = modal.querySelector('.sf-bra-btn[data-value="C"]');
    if (cBtn) cBtn.classList.add('selected');
    var braSection = modal.querySelector('#sfBraSection');
    if (braSection) braSection.style.display = 'none';

    modal.querySelectorAll('.sf-fit-btn').forEach(function(b) { b.classList.remove('selected'); });
    var regBtn = modal.querySelector('.sf-fit-btn[data-value="regular"]');
    if (regBtn) regBtn.classList.add('selected');

    showCurrentStep();
  }

  function renderIcons() {
    // Gender icons — fetch inline
    loadSvgInline(ICON_URLS.gender.male, modal.querySelector('#sfGenderMaleIcon'));
    loadSvgInline(ICON_URLS.gender.female, modal.querySelector('#sfGenderFemaleIcon'));

    // Tummy options
    ['flat', 'average', 'round'].forEach(function(val) {
      var btn = document.createElement('button');
      btn.className = 'sf-body-btn' + (val === 'flat' ? ' selected' : '');
      btn.type = 'button';
      btn.dataset.group = 'tummy'; btn.dataset.value = val;
      btn.addEventListener('click', function() { selectBody(this); });
      var iconSpan = document.createElement('span');
      iconSpan.className = 'sf-body-btn-icon';
      loadSvgInline(ICON_URLS.tummy[val], iconSpan);
      btn.appendChild(iconSpan);
      btn.appendChild(document.createTextNode(val.charAt(0).toUpperCase() + val.slice(1)));
      modal.querySelector('#sfTummyOptions').appendChild(btn);
    });

    // Hip options
    ['narrow', 'average', 'wide'].forEach(function(val) {
      var btn = document.createElement('button');
      btn.className = 'sf-body-btn' + (val === 'average' ? ' selected' : '');
      btn.type = 'button';
      btn.dataset.group = 'hips'; btn.dataset.value = val;
      btn.addEventListener('click', function() { selectBody(this); });
      var iconSpan = document.createElement('span');
      iconSpan.className = 'sf-body-btn-icon';
      loadSvgInline(ICON_URLS.hips[val], iconSpan);
      btn.appendChild(iconSpan);
      btn.appendChild(document.createTextNode(val.charAt(0).toUpperCase() + val.slice(1)));
      modal.querySelector('#sfHipOptions').appendChild(btn);
    });

    // Bra options
    ['A', 'B', 'C', 'D', 'DD+'].forEach(function(val) {
      var btn = document.createElement('button');
      btn.className = 'sf-bra-btn' + (val === 'C' ? ' selected' : '');
      btn.type = 'button';
      btn.dataset.value = val;
      btn.addEventListener('click', function() { selectBra(this); });
      var iconSpan = document.createElement('span');
      iconSpan.className = 'sf-bra-btn-icon';
      loadSvgInline(ICON_URLS.bra[val], iconSpan);
      btn.appendChild(iconSpan);
      btn.appendChild(document.createTextNode(val));
      modal.querySelector('#sfBraOptions').appendChild(btn);
    });

    // Fit options
    ['fitted', 'regular', 'relaxed'].forEach(function(val) {
      var btn = document.createElement('button');
      btn.className = 'sf-fit-btn' + (val === 'regular' ? ' selected' : '');
      btn.type = 'button';
      btn.dataset.value = val;
      btn.addEventListener('click', function() { selectFit(this); });
      var iconSpan = document.createElement('span');
      iconSpan.className = 'sf-fit-icon';
      loadSvgInline(ICON_URLS.fit[val], iconSpan);
      btn.appendChild(iconSpan);
      btn.appendChild(document.createTextNode(val.charAt(0).toUpperCase() + val.slice(1)));
      modal.querySelector('#sfFitOptions').appendChild(btn);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
